<template>
  <div class="text-center">
    <v-combobox
      v-model="brand"
      :items="items"
      :label="label"
      :disabled="disabled"
      :rules="rules"
      @focus="onFocus"
      @blur="onBlur"
      @update:search-input="onInput"
      @change="onSelect"
      item-text="title"
    >
      <template v-slot:append>
        <v-fade-transition leave-absolute>
          <v-progress-circular
            v-if="loading"
            size="24"
            color="info"
            indeterminate
          ></v-progress-circular>
        </v-fade-transition>
      </template>
    </v-combobox>
    <p
      v-if="isHint"
      class="text-left hint"
    >
      {{ $t('auto.addBrand.hint') + ` "${input}"` }}
      <v-btn
        class="ml-5 justify-end"
        outlined
        color="warning"
        @click="addBrand()"
      >
        {{ $t('common.button.add') }}
      </v-btn>
    </p>
    <p
      v-if="error"
      class="text-left error-message"
    >
      {{ error }}
    </p>
  </div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex';

export default {
  name: 'BrandSelect',
  data() {
    return {
      input: '',
      disabled: false,
      loading: false,
      isTimeout: false,
      items: [],
      error: false,
    };
  },
  computed: {
    brand: {
      get() {
        return this.$store.getters['auto/getAutoBrand'];
      },
      set(value) {
        return this.$store.commit('auto/setAutoFormBrand', value);
      },
    },
    isHint() {
      if (this.items.length === 0 && this.input !== '' && this.input !== null) {
        return true;
      }
      if (this.items.length && this.input !== '' && !this.searchItem()) {
        return true;
      }
      return false;
    },
  },
  props: {
    label: String,
    rules: Array,
  },
  methods: {
    ...mapActions({
      loadBrands: 'auto/fetchBrandsData',
      createBrand: 'auto/createBrand',
    }),
    ...mapMutations({
      setBrand: 'auto/setAutoFormBrand',
    }),
    setLoading(state) {
      this.loading = state;
      this.disabled = state;
      return state;
    },
    onBlur(item) {
      if (this.items.length === 1 && item.srcElement.value === this.items[0].title) {
        this.setBrand(this.items[0]);
      } else if ((this.brand.id === null || typeof this.brand.id === 'undefined') && item.srcElement.value !== '') {
        this.hint = true;
      }
    },
    async onFocus(item) {
      this.loading = true;
      // load default items
      try {
        const brands = await this.loadBrands(item.target.value);
        this.items = brands;
        this.error = false;
      } catch (error) {
        this.error = error.message;
      }
      this.loading = false;
    },
    async onInput(input) {
      if (input === null) {
        this.hint = false;
        return true;
      }
      if (input === '') {
        this.hint = false;
      }
      this.input = input;
      const that = this;
      if (!this.isTimeout) {
        this.isTimeout = true;
        // wait 1 second and loading data
        setTimeout(async () => {
          const title = that.input;
          that.isTimeout = false;
          const brands = await that.loadData(title);
          that.items = brands;
          that.error = false;
          that.loading = false;
        }, 500);
      }
      this.loading = false;
      return true;
    },
    async loadData(searchString) {
      this.loading = true;
      let brands = [];
      try {
        brands = await this.loadBrands(searchString);
      } catch (error) {
        this.error = error.message;
      }
      this.loading = false;
      return brands;
    },
    onSelect() {
      if (this.brand.id) {
        this.hint = false;
      }
    },
    async addBrand() {
      this.error = false;
      // add new car brand
      try {
        const { input } = this;
        const brandId = await this.createBrand(input);
        if (brandId) {
          this.setBrand({ id: brandId, title: input });
          this.hint = false;
          this.error = false;
        } else {
          this.error = this.$t('common.errors.APIerror');
        }
      } catch (error) {
        this.error = error.message;
      }
      this.setLoading(false);
    },
    searchItem() {
      let find = false;
      this.items.forEach((element) => {
        if (this.input === element.title) {
          find = true;
        }
      });

      return find;
    },
  },
};
</script>

<style lang="scss" scoped>
.hint {
  color: #ff8a1f;
}
.error-message {
  color: red;
}
</style>
